/*
 * ORBIT CUSTOMER DATE CLARITY
 * Customer-facing copy only. This file does not alter Recharge, checkout,
 * payment schedules, fulfilment, membership activation or backend records.
 */
(function () {
  'use strict';

  var MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];

  function ordinal(day) {
    var mod100 = day % 100;
    if (mod100 >= 11 && mod100 <= 13) return day + 'th';
    if (day % 10 === 1) return day + 'st';
    if (day % 10 === 2) return day + 'nd';
    if (day % 10 === 3) return day + 'rd';
    return day + 'th';
  }

  function londonToday() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        day: 'numeric',
        month: 'numeric',
        year: 'numeric'
      }).formatToParts(new Date());
      var values = {};
      parts.forEach(function (part) {
        if (part.type !== 'literal') values[part.type] = Number(part.value);
      });
      if (!values.year || !values.month || !values.day) return null;
      return { year: values.year, monthIndex: values.month - 1, day: values.day };
    } catch (error) {
      return null;
    }
  }

  function firstOfMonth(today, monthOffset) {
    var date = new Date(Date.UTC(today.year, today.monthIndex + monthOffset, 1));
    return {
      year: date.getUTCFullYear(),
      monthIndex: date.getUTCMonth(),
      day: 1
    };
  }

  function formatDate(date, baseYear) {
    var value = ordinal(date.day) + ' ' + MONTHS[date.monthIndex];
    if (date.year !== baseYear) value += ' ' + date.year;
    return value;
  }

  function setText(key, text) {
    document.querySelectorAll('[data-occ-date-copy="' + key + '"]').forEach(function (element) {
      element.textContent = text;
    });
  }

  function setHtml(key, html) {
    document.querySelectorAll('[data-occ-date-copy="' + key + '"]').forEach(function (element) {
      element.innerHTML = html;
    });
  }

  function applyDateCopy() {
    var today = londonToday();
    if (!today) return;

    var firstPayment = firstOfMonth(today, 1);
    var introRenewalOne = firstOfMonth(today, 2);
    var introRenewalTwo = firstOfMonth(today, 3);
    var standardRate = firstOfMonth(today, 4);

    var todayLabel = formatDate(today, today.year);
    var firstPaymentLabel = formatDate(firstPayment, today.year);
    var introOneLabel = formatDate(introRenewalOne, today.year);
    var introTwoLabel = formatDate(introRenewalTwo, today.year);
    var standardLabel = formatDate(standardRate, today.year);
    var firstParcelMonth = MONTHS[firstPayment.monthIndex] + (firstPayment.year !== today.year ? ' ' + firstPayment.year : '');

    setText('homepage-membership-price',
      'Join today on ' + todayLabel + ' for £1 to verify your details and secure a Pending membership. Members Area access opens immediately; benefits and parcel fulfilment unlock only after the first full £33.95 payment succeeds on ' + firstPaymentLabel + ', followed by introductory pricing before the regular membership rate.'
    );
    setText('homepage-first-parcel',
      'We aim to dispatch member parcels during the first week of each month. If you signed up today, your first parcel would be dispatched during the first week of ' + firstParcelMonth + '.'
    );

    setHtml('product-intro',
      'Join today on <strong>' + todayLabel + '</strong> for just <strong>£1</strong> to verify your details, secure your membership and open the Members Area. Your benefits and first Collector Box unlock only after your first full <strong>£33.95</strong> payment succeeds on <strong>' + firstPaymentLabel + '</strong>. You then pay <strong>£34.95</strong> on <strong>' + introOneLabel + '</strong> and <strong>' + introTwoLabel + '</strong>, before the standard <strong>£39.95</strong> monthly rate begins on <strong>' + standardLabel + '</strong>.'
    );
    setText('journey-today-title', todayLabel + ': £1');
    setText('journey-today-detail', 'Verify your details and secure your Pending membership.');
    setText('journey-first-payment-title', firstPaymentLabel + ': £33.95');
    setText('journey-intro-renewals-title', introOneLabel + ' and ' + introTwoLabel + ': £34.95');
    setText('journey-standard-title', 'From ' + standardLabel + ': £39.95/month');
    setText('journey-standard-detail', 'Your standard monthly membership price begins.');

    setText('product-legal-note',
      'Membership renews automatically. £1 is charged on ' + todayLabel + ' to verify your details and create your Pending membership. Members Area access opens immediately, but benefits and parcel fulfilment remain locked until your first full £33.95 payment succeeds on ' + firstPaymentLabel + '. This is followed by £34.95 on ' + introOneLabel + ' and ' + introTwoLabel + '. The standard £39.95 monthly rate begins on ' + standardLabel + '. You can cancel at any time in accordance with our membership terms.'
    );
    setText('product-faq-price',
      'Start today on ' + todayLabel + ' with a £1 verification payment. Your membership remains Pending until the first full £33.95 payment succeeds on ' + firstPaymentLabel + '. You then pay £34.95 on ' + introOneLabel + ' and ' + introTwoLabel + '. The standard £39.95 monthly rate begins on ' + standardLabel + '.'
    );
    setText('product-faq-parcel',
      'Monthly parcels ship during the first week of each month while your membership remains active. If you signed up today, your first parcel would be dispatched during the first week of ' + firstParcelMonth + '.'
    );

    // Event Upgrade is active immediately. Recharge uses two safe schedules:
    // • joining ON the 1st: today funds the current month and the next charge is
    //   the very next 1st (for example 1 September → 1 October);
    // • joining AFTER the 1st: today funds the current month and the next
    //   calendar month is included, avoiding a second £34.95 charge only days
    //   later (for example 13 August → 1 October).
    // This is display copy only and mirrors the already-certified billing rules.
    var upgradeOnBillingDay = today.day === 1;
    var upgradeFreeBridge = firstOfMonth(today, 1);
    var upgradeNextPayment = firstOfMonth(today, upgradeOnBillingDay ? 1 : 2);
    var upgradeIntroRenewal = firstOfMonth(today, upgradeOnBillingDay ? 2 : 3);
    var upgradeStandardRate = firstOfMonth(today, upgradeOnBillingDay ? 3 : 4);
    var upgradeFreeBridgeLabel = formatDate(upgradeFreeBridge, today.year);
    var upgradeNextLabel = formatDate(upgradeNextPayment, today.year);
    var upgradeIntroLabel = formatDate(upgradeIntroRenewal, today.year);
    var upgradeStandardLabel = formatDate(upgradeStandardRate, today.year);
    var upgradeCurrentMonth = MONTHS[today.monthIndex];
    var upgradeFirstBoxMonth = MONTHS[upgradeFreeBridge.monthIndex] + (upgradeFreeBridge.year !== today.year ? ' ' + upgradeFreeBridge.year : '');
    setText('upgrade-journey-today-title', todayLabel + ': £34.95');
    setText('upgrade-journey-today-detail', 'Your membership activates immediately.');
    if (upgradeOnBillingDay) {
      setText('upgrade-free-bridge-title', upgradeCurrentMonth + ' membership starts today.');
      setText('upgrade-free-bridge-detail', 'Today’s payment includes your ' + upgradeCurrentMonth + ' membership box and benefits.');
    } else {
      setText('upgrade-free-bridge-title', 'Nothing is charged on ' + upgradeFreeBridgeLabel + '.');
      setText('upgrade-free-bridge-detail', upgradeFirstBoxMonth + ' membership is included in your initial signup, including your membership box and benefits.');
    }
    setText('upgrade-next-payment-title', upgradeNextLabel + ': £34.95 — Your first rebill');
    setText('upgrade-next-payment-detail', 'This payment covers your ' + MONTHS[upgradeNextPayment.monthIndex] + ' membership box and benefits.');
    setText('upgrade-intro-renewals-title', upgradeIntroLabel + ': £34.95 — Second rebill');
    setText('upgrade-standard-title', 'From ' + upgradeStandardLabel + ': £39.95/month');
    if (upgradeOnBillingDay) {
      setText('upgrade-legal-note', 'Membership renews automatically. £34.95 is charged on ' + todayLabel + ' and membership activates immediately. Your first rebill is £34.95 on ' + upgradeNextLabel + ', followed by £34.95 on ' + upgradeIntroLabel + '. The standard £39.95 monthly rate begins on ' + upgradeStandardLabel + '. You can cancel at any time in accordance with our membership terms.');
      setText('upgrade-faq-price', 'Pay £34.95 on ' + todayLabel + ' and membership activates immediately. Your first rebill is £34.95 on ' + upgradeNextLabel + ', then £34.95 on ' + upgradeIntroLabel + '. The standard £39.95 monthly rate begins on ' + upgradeStandardLabel + '.');
    } else {
      setText('upgrade-legal-note', 'Membership renews automatically. £34.95 is charged on ' + todayLabel + ' and membership activates immediately. Nothing is charged on ' + upgradeFreeBridgeLabel + ' because ' + upgradeFirstBoxMonth + ' membership is included in your initial signup. Your first rebill is £34.95 on ' + upgradeNextLabel + ', followed by £34.95 on ' + upgradeIntroLabel + '. The standard £39.95 monthly rate begins on ' + upgradeStandardLabel + '. You can cancel at any time in accordance with our membership terms.');
      setText('upgrade-faq-price', 'Pay £34.95 on ' + todayLabel + ' and membership activates immediately. Nothing is charged on ' + upgradeFreeBridgeLabel + ' because ' + upgradeFirstBoxMonth + ' membership is included in the initial signup. Your first rebill is £34.95 on ' + upgradeNextLabel + ', then £34.95 on ' + upgradeIntroLabel + '. The standard £39.95 monthly rate begins on ' + upgradeStandardLabel + '.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyDateCopy, { once: true });
  } else {
    applyDateCopy();
  }
})();
